import { Box, Dialog, Text } from '@digibee/beehive-ui';
import { Button } from '@heroui/react';
import React, { useState } from 'react';

import DeployPipeline from './DeployPipeline';

import api from '~/api/runtime';
import i18n from '~/common/helpers/i18n';
import useSnackbar from '~/common/hooks/useSnackbar';
import { EnvironmentTag } from '~/components/EnvironmentTag';
import { Deployment } from '~/entities/Deployment';

type Props = {
  onClose: () => void;
  confirmDeploy: (value: any) => void;
  dataModal: {
    deployment: Deployment;
    texts: {
      title: string;
      text: string;
      confirmText: string;
    };
    isRedeploy: boolean;
    environment: string;
  };
};

const DeployPipelineDialogV2: React.FC<Props> = props => {
  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();

  async function confirmDeploy() {
    try {
      setLoading(true);
      await api.createV2(props.dataModal);

      props.confirmDeploy(props.dataModal);
      props.onClose();
      setLoading(false);
      snackbar.createSnack(
        i18n.t('scenes.runtime.labels.upper_and_capitalize.capitalized', {
          item: `${i18n.t('scenes.runtime.messages.success.item_deployed')}`
        })
      );
    } catch (error) {
      setLoading(false);

      const formatError = (message: string) =>
        message.replace('GraphQL error:', '').replace('ApolloError: ', '');

      if (error instanceof Error) {
        snackbar.createSnack(formatError(error.message));
      }

      if (typeof error === 'string') {
        snackbar.createSnack(formatError(error));
      }

      console.error(error);
    }
  }
  return (
    <>
      <Dialog.Root open onOpenChange={props.onClose}>
        <React.Fragment key='.0'>
          <Dialog.Content
            style={{ width: '100rem', maxHeight: '98vh', overflow: 'auto' }}
          >
            <Box css={{ marginTop: '32px', marginLeft: '16px' }}>
              <EnvironmentTag />
            </Box>
            <Box css={{ margin: '$3' }}>
              <Text as='h1' variant='h4'>
                {i18n.t(props.dataModal.texts.title, {
                  pipelineName: props.dataModal.deployment.pipeline?.name
                })}
              </Text>
              <DeployPipeline
                environment={props.dataModal.environment || ''}
                // @ts-expect-error
                deployment={props.dataModal.deployment}
                isRedeploy={props.dataModal.isRedeploy}
              />

              <Dialog.Footer>
                <Button
                  variant='solid'
                  color='primary'
                  className='px-3 py-2'
                  onClick={() => {
                    confirmDeploy();
                  }}
                  isLoading={loading}
                  data-testid={
                    props.dataModal.isRedeploy
                      ? 'button-confirm-redeploy'
                      : 'button-confirm-deploy'
                  }
                >
                  {i18n.t(props.dataModal.texts.confirmText)}
                </Button>
                <Dialog.Close asChild>
                  <Button variant='solid' color='default' className='px-3 py-2'>
                    {i18n.t('action.cancel')}
                  </Button>
                </Dialog.Close>
              </Dialog.Footer>
            </Box>
          </Dialog.Content>
        </React.Fragment>
      </Dialog.Root>
    </>
  );
};

export default DeployPipelineDialogV2;
